/* global axios */
import ApiClient from './ApiClient';

class LiveReportsAPI extends ApiClient {
  constructor() {
    super('live_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getConversationMetric(params = {}) {
    return axios.get(`${this.url}/conversation_metrics`, { params });
  }

  getGroupedConversations(
    { groupBy, inboxId, teamIds } = { groupBy: 'assignee_id' }
  ) {
    return axios.get(`${this.url}/grouped_conversation_metrics`, {
      params: { group_by: groupBy, inbox_id: inboxId, team_id: teamIds },
    });
  }

  getWaitingConversations(params = {}) {
    return axios.get(`${this.url}/waiting_conversations`, { params });
  }

  getWaitingMoreThan24h(params = {}) {
    return axios.get(`${this.url}/waiting_more_than_24h`, { params });
  }
}

export default new LiveReportsAPI();
